let dt = null;

export function index(){

    dt = $('#logs_table').DataTable({
        ajax: {
            url: $('#logs_table').attr('url'),
        },
        columns: [
            { width: 120, data: 'created_at', orderable: true, searchable: false, render: datatables.render_datetime_seconds },
            { data: 'user_friendly', orderable: false, searchable: true, render: datatables.render_small_newline },
            { data: 'action', orderable: false, searchable: false },
            { data: 'model', orderable: false, searchable: true, render: datatables.render_small_newline },
            { data: 'model_friendly', orderable: false, searchable: true, render: datatables.render_small_newline },
            { data: 'changes', orderable: false, searchable: true, render: datatables.render_array },
        ],
        order: [[0, 'desc']],
    });

    // dt.on('init', function(e, settings, json){
    // });

    // dt.on('draw', function(e, settings){
    // });

}

export function index_reload(){
    dt.ajax.reload();
}